// 
export const valueResponsiveMenu = 1019; // valeur du breakpoint sous lequel le menu mobile s'active

export let witdhWindow;

// Test si on est sur une largeur mobile
export function isMobile() {
    witdhWindow = window.innerWidth;

    if (witdhWindow <= valueResponsiveMenu) {
        document.body.classList.add('mobile');
        return true;
    } else {
        document.body.classList.remove('mobile');
        document.body.classList.remove('no-scroll');
        return false;
    }
}